import { leadManagementStatus, roleIds } from 'utils/Constants'

export const PELIN_TURKER_EMAIL = 'pturker@nuevo.com.tr'

const sameId = (a, b) => Number(a) === Number(b)

const userEmail = (user) => (user?.email || user?.mail || user?.userName || '').trim().toLowerCase()

export const isPelinTurker = (user) => userEmail(user) === PELIN_TURKER_EMAIL

export const isOpenLead = (lead) => {
    if (!lead || lead.isArchived) return false
    const status = Number(lead.status)
    if (Number.isNaN(status)) return false
    return status !== leadManagementStatus.approved.value && status !== leadManagementStatus.rejected.value
}

export const canBeReminderRecipient = (user) => {
    const ids = user?.roles?.map((role) => role.id) || []
    return ids.includes(roleIds.accountManager)
        || ids.includes(roleIds.projectManager)
        || ids.includes(roleIds.admin)
        || isPelinTurker(user)
}

export const toReminderUserOption = (user) => ({
    label: `${user.firstName || ''} ${user.lastName || ''}`.trim(),
    value: user.id,
    email: user.email || user.mail || user.userName || '',
    roles: user.roles || []
})

export const buildPelinAutoRecipient = ({ leads, users, currentUserId }) => {
    const openLeads = (leads || []).filter(isOpenLead)
    const pelin = (users || []).find(isPelinTurker)
    const recipientName = pelin?.label || 'Pelin Türker'
    if (!openLeads.length || !pelin) {
        return { autoUserIds: [], openLeadCount: openLeads.length, recipientName }
    }
    const pelinId = Number(pelin.value ?? pelin.id)
    if (currentUserId != null && sameId(currentUserId, pelinId)) {
        return { autoUserIds: [], openLeadCount: openLeads.length, recipientName }
    }
    return { autoUserIds: [pelinId], openLeadCount: openLeads.length, recipientName }
}

export const removeAutoRecipients = (userIds = [], autoUserIds = []) => {
    const auto = new Set((autoUserIds || []).map(Number))
    return (userIds || []).map(Number).filter((id) => !Number.isNaN(id) && !auto.has(id))
}

export const mergeAutoRecipients = (userIds = [], autoUserIds = []) => {
    const current = (userIds || []).map(Number).filter((id) => !Number.isNaN(id))
    const toAdd = (autoUserIds || []).map(Number).filter((id) => !Number.isNaN(id) && !current.includes(id))
    return { userIds: [...current, ...toAdd], autoUserIds: toAdd }
}

export const openLeadReminderMessage = (openLeadCount, recipientName) => {
    const countText = openLeadCount === 1 ? '1 açık lead' : `${openLeadCount} açık lead`
    return `Bu müşterinin açık lead'i var (${countText}). ${recipientName} alıcı olarak otomatik eklendi, isterseniz çıkarabilirsiniz.`
}

export const idsInclude = (ids, value) => (ids || []).some((id) => sameId(id, value))
